export function areFlightSearchEndpointsSame(originId, destinationId) {
  const o = originId == null ? '' : String(originId).trim().toUpperCase();
  const d = destinationId == null ? '' : String(destinationId).trim().toUpperCase();
  return Boolean(o && d && o === d);
}

export function flightAirportSearchKey(p) {
  if (!p) return '';
  if (p.id != null && !Number.isNaN(Number(p.id))) {
    return `id:${Number(p.id)}`;
  }
  const cc = (p.cityCode && String(p.cityCode).trim()) || '';
  const ac = (p.airportCode && String(p.airportCode).trim()) || '';
  const cn = (p.cityName && String(p.cityName).trim().slice(0, 64)) || '';
  return `c:${cc}:a:${ac}:n:${cn}`;
}

export function flightAirportsAreSame(a, b) {
  if (!a || !b) return false;
  const idA = a.id;
  const idB = b.id;
  if (idA != null && idB != null && !Number.isNaN(Number(idA)) && !Number.isNaN(Number(idB))) {
    return Number(idA) === Number(idB);
  }
  const apA = a.airportCode && String(a.airportCode).trim();
  const apB = b.airportCode && String(b.airportCode).trim();
  if (apA && apB) return apA === apB;
  const cA = a.cityCode && String(a.cityCode).trim();
  const cB = b.cityCode && String(b.cityCode).trim();
  return Boolean(cA && cB && cA === cB);
}
